//
// dashkit.js
// Theme module
//

'use strict';

// Orders select
//
// Select all checkboxes
(function() {
  //
  // Functions
  //

  function selectAll(el) {
    var ordersSelect = document.querySelectorAll('[name="ordersSelect"]');
    [].forEach.call(ordersSelect, function(checkbox) {
      checkbox.checked = el.checked;
    });
  }

  //
  // Events
  //

  $(document).on('change', '#ordersSelectAll', function() {
    selectAll(this);
  });

}) ();
